import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import { saveStudentPhotoSvc, removePtmTopperSvc } from "../slidesSvc";

function TopperForm(props) {
    const { setEditLoader, setEditOpacity, ptmId, sectionId, examId, studentId, student, topperRank, score, setScore, imgPath, updateKey, closeSlider } = props;


    const [studentName, setStudentName] = useState("");
    const [photoPath, setPhotoPath] = useState(window.appURL + "/no-image.png");
    const [photoFile, setPhotoFile] = useState(null); // State to store the file

    useEffect(() => {
        // console.log("TopperForm called");
        // console.log("ptmId", ptmId);
        setStudentName(student);
    }, [student, studentId]);
    useEffect(() => {
        // console.log("TopperForm called");
        // console.log("imgPath", imgPath);
        if (!!imgPath)
            setPhotoPath(imgPath);
    }, [imgPath]);

    const handlePhotoChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setPhotoFile(file); // Save the file in state
            setPhotoPath(URL.createObjectURL(file)); // Show a preview
        }
    };

    const handlePhotoClick = () => {
        // Trigger file input click
        document.getElementById("img_photoId").click();
    };

    const onError = () => {
        setPhotoPath(window.appURL + "/no-image.png");
    };

    const handleSubmit = () => {
        // console.log("handleSubmit called");
        if (!studentName) {
            toast.warn("Please enter student name");
            return;
        }
        if (!score) {
            toast.warn("Please enter student score");
            return;
        }
        const ptmTopper = {
            ptmId,
            sectionId,
            examId,
            topperRank,
            studentId,
            "student": studentName,
            score,
            "fileName": photoFile ? photoFile.name : ""
        }
        // console.log("ptmTopper", ptmTopper);
        if (photoFile) {
            // console.log("Image file ready to upload:", photoFile);
            setEditLoader("block");
            setEditOpacity(0.5);
            saveStudentPhotoSvc(ptmTopper, photoFile, saveStudentResponse);
        } else if (imgPath) {
            // console.log("Using existing image from imgPath.");
            fetch(imgPath)
                .then(response => response.blob())
                .then(blob => {
                    const file = new File([blob], imgPath.split('/').pop(), { type: blob.type });
                    setEditLoader("block");
                    setEditOpacity(0.5);
                    ptmTopper.fileName = file.name || "";
                    saveStudentPhotoSvc(ptmTopper, file, saveStudentResponse); // Use the created file
                })
                .catch(error => {
                    console.error("Error fetching the image:", error);
                    toast.error("Failed to process the displayed image. Please upload a new one.");
                });
        } else {
            // console.log("No image file selected.");
        }
    };


    const saveStudentResponse = (data) => {
        // console.log("saveStudentResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            updateKey();
            closeSlider();
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setEditLoader("none");
        setEditOpacity(1);
    }

    const removStudentResponse = (data) => {
        // console.log("removStudentResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            updateKey();
            closeSlider();
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setEditLoader("none");
        setEditOpacity(1);
    }


    const removeStudent = () => {
        // console.log("removeStudent called");
        removePtmTopperSvc(ptmId, sectionId, topperRank, removStudentResponse);
    }


    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    return (
        <div className="col-sm-12 col-xs-12 padding-remove">
            <div className="col-sm-12 col-md-12 padding-remove" style={{ width: "94%", margin: "3%", background: "#fff", border: "1px solid #ccc", borderRadius: 10 }}>
                <form id="editTopperForm" className="form form-horizontal" style={{ height: "80vh", overflowX: "hidden", padding: "20px 20px 5px 20px" }}>
                    <div className="form-group col-md-12 padding-remove">
                        <label className="control-label col-md-3 col-xs-6" style={{ padding: "7px 10px 0 0" }}>
                            Name:
                        </label>
                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <input
                                type="text"
                                className="form-control"
                                value={studentName}
                                onChange={(e) => setStudentName(e.target.value)}
                                disabled={!!studentId}
                                placeholder="Student Name"
                            />
                        </div>
                    </div>
                    <div className="form-group col-md-12 padding-remove">
                        <label className="control-label col-md-3 col-xs-6" style={{ padding: "7px 10px 0 0" }}>
                            Score:
                        </label>
                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <input
                                type="text"
                                className="form-control"
                                value={score}
                                onChange={(e) => setScore(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="form-group col-md-12 padding-remove">
                        <label className="control-label col-md-3 col-xs-6" style={{ padding: "7px 10px 0 0" }}>
                            Photo:
                        </label>
                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <input
                                type="file"
                                id="img_photoId"
                                name="img"
                                onChange={handlePhotoChange}
                                className="hidden"
                                accept="image/*"
                                disabled={studentId === 0}
                            />
                            <img
                                src={photoPath}
                                alt="img"
                                onClick={handlePhotoClick}
                                height="160"
                                width="160"
                                style={{ width: 160, border: "1px solid #ddd" }}
                                onError={onError}
                            />
                        </div>
                    </div>
                    <div className="col-sm-10 padding-remove" style={{ height: "50px", marginTop: "30px" }}>
                        <div className="col-sm-6 col-md-6 padding-remove pull-right">
                            <div className="col-sm-6 col-md-6 padding-remove ">
                                <button type="button" onClick={() => removeStudent()} className="btn btn-primary">
                                    Remove
                                </button>
                            </div>
                            <div className="col-sm-6 col-md-6 padding-remove ">
                                <button type="button" onClick={() => handleSubmit()} className="btn btn-primary">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default TopperForm;
